import { render, staticRenderFns } from "./BandejaQuejas.vue?vue&type=template&id=7cabd185&scoped=true"
import script from "./BandejaQuejas.vue?vue&type=script&lang=js"
export * from "./BandejaQuejas.vue?vue&type=script&lang=js"
import style0 from "./BandejaQuejas.vue?vue&type=style&index=0&id=7cabd185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cabd185",
  null
  
)

export default component.exports